import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import useHelpers from '../context/useHelpers';
import { SCREEN_TABS, linkedTab } from '../../navigation/screenTabs';

/**
 * Opens the tab a link names (QL22: `?tab=delivery`) on a page of SCREEN_TABS: when the page opens with it, and again
 * for each new link to it (a second Open link while the page shows). The tab goes into the page's own active-tab store
 * (useHelpers), so the person moves between tabs as before. `hidden`: tabs this person doesn't get, which a link can't
 * open. Before paint, so the page never shows the old tab first.
 */
export default function useLinkedTab(path, { hidden = [] } = {}) {
  const { search, key } = useLocation();
  const { setActiveTab } = useHelpers();
  const page = SCREEN_TABS[path];
  const tab = page
    ? linkedTab(
        search,
        page.tabs.filter((candidate) => !hidden.includes(candidate)),
        page.aliases,
      )
    : null;
  // setActiveTab changes with every tab it sets: the latest, without opening the link's tab again.
  const set = useRef(setActiveTab);
  set.current = setActiveTab;

  useLayoutEffect(() => {
    if (tab) {
      set.current(tab, page.store);
    }
  }, [tab, page, key]);
}
